@if (isEditing) {
    <div class="o-grid">
        <div class="o-grid__row">
            <span>In order to process payment, patient documentation should be uploaded here if requested by PCS.</span>
        </div>
        <div class="o-grid__row"></div>
        <div class="o-grid__row">
            <div class="o-grid__field">
                <medpace-upload
                    id="kyc-upload-document"
                    [idVal]="'kyc-upload-document-file'"
                    [acceptableTypes]="acceptableFileTypes"
                    [inputFileId]="patientIdent.KYCDocumentInfoId"
                    [downloadFileFn]="downloadAttachment(patient.id, patientIdent.KYCDocumentInfoId)"
                    (emitStuff)="updateDocumentation($event, { id: 'KYCDocument' })"
                    (fileNameEmitter)="updateDocumentation($event, { id: 'KYCDocumentName' })"
                    uploadButtonTitle="Upload Document"
                ></medpace-upload>
            </div>
        </div>
        @if (isAdmin) {
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-checkbox
                        label="Ready for Payment"
                        [formCtrl]="kycCardFormGroup.controls.readyForPaymentControl"
                        [disabled]="siteSettings?.kycDocumentation && !hasFile"
                        id="readyForPayment"
                        (changeEvent)="emitChange($event)"
                    >
                    </mds-checkbox>
                </div>
            </div>
        }
        @if (isAdmin && patient?.readyForPayment) {
            <div class="o-grid__row">
                <div class="o-grid__field">
                    <mds-text-field
                        [appearance]="'outline'"
                        id="KYCVendorId"
                        label="Vendor ID"
                        [formCtrl]="kycCardFormGroup.controls.kycVendorIdControl"
                        placeholder="Type here..."
                        (input)="emitStringChange($event, { id: 'KYCVendorId' })"
                    ></mds-text-field>
                </div>
            </div>
        }
        @if (isAdmin && patient?.readyForPayment) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <span class="note">
                        Approved by {{ patient.paymentApprover }} on
                        {{ patient.paymentApprovalDate?.toDate() | dateFormat | uppercase }}
                    </span>
                </div>
            </div>
        }
    </div>
}

@if (!isEditing) {
    <div class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__item">
                <span
                    >In order to process payment, patient documentation should be uploaded here if requested by
                    PCS.</span
                >
            </div>
        </div>
        <div class="o-grid__row">
            @if (hasFile) {
                <div class="o-grid__item">
                    <div class="flex flex-row start gap-medpace">
                        <mds-button
                            [id]="'kyc-document-download-btn'"
                            color="primary"
                            [variant]="'outline'"
                            label="KYC document download"
                            (clickEvent)="onDocumentDownloadClick()"
                        >
                        </mds-button>
                        @if (isAdmin) {
                            <mds-icon-button
                                [id]="'delete-btn'"
                                [icon]="'delete'"
                                (clickEvent)="deleteFile()"
                                [tooltip]="'Delete'"
                                class="danger outline"
                                width="50px"
                            ></mds-icon-button>
                        }
                    </div>
                </div>
            }
        </div>
        <div class="o-grid__row">
            <div class="o-grid__item">
                <mat-checkbox
                    disabled
                    id="readyForPayment"
                    [(ngModel)]="patient.readyForPayment"
                    [checked]="patient.readyForPayment"
                    (change)="emitChange($event)"
                >
                    Ready for Payment
                </mat-checkbox>
            </div>
        </div>
        @if (isAdmin && patient?.readyForPayment) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Vendor ID</h5>
                        <span>{{ patientIdent.KYCVendorId }}</span>
                    </div>
                </div>
            </div>
        }
        @if (patient?.readyForPayment) {
            <div class="o-grid__row">
                <span class="note">
                    Approved by {{ patient.paymentApprover }} on
                    {{ patient.paymentApprovalDate?.toDate() | dateFormat | uppercase }}
                </span>
            </div>
        }
    </div>
}
